import Icon from "../../../../Elements/Icon/Icon.tsx";
import LoaderContainer from "../../../../Reusable/LoaderContainer/LoaderContainer.js";
import { useEffect, useState, useRef } from "react";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import config from "config";
import Button from "../../../../Elements/Button/Button.js";
import DynamicEmbedForm from "./DynamicEmbedForm.js";
import Recaptcha from "components/Reusable/Recaptcha/Recaptcha.tsx";
import { LinkToNewTab } from "../../../../Elements/Link/Link.js";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";
import CreateEmbedPageModalNew from "../Modals/CreateEmbedPageModalNew.js";
import { useUser } from "contexts/userContext/userContext.js";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import useBucketName from "hooks/useBucketName.ts";
import usePageInit from "hooks/usePageInit.ts";
import { awaiter } from "components/Pages/Home/Helpers/helpers.js";
import { RECAPTCHA_APPEAR_DELAY } from "utils/globalConsts.ts";

const FormManagement = ({
  userData,
  dynamicFormsList,
  setDynamicFormsList,
  emptyListForms,
  setEmptyListForms,
  notExistEmbedPage,
  setNotExistEmbedPage,
  embedPageUserName,
  setEmbedPageUserName,
}) => {
  //const [dynamicFormsList, setDynamicFormsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCreatePage, setLoadingCreatePage] = useState(false);
  const { isPremium } = useUser();
  const { getBasicSettingsData } = useContent();
  //const [emptyListForms, setEmptyListForms] = useState(false);
  const { setModal } = useModal();
  const [isUpdateFormList, setIsUpdateFormList] = useState(false);
  const [loadingFormId, setLoadingFormId] = useState([]);
  const {
    getTextByKey,
    getPath,
    getDirection,
    getLanguageCulture,
    getLanguage,
  } = useContent();

  const { getUserData } = useUser();
  const bucketName = useBucketName();
  const [isCaptchaShown, setIsCaptchaShown] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");
  const recaptchaRef = useRef();
  const [submitData, setSubmitData] = useState({});

  const { isPageReady } = usePageInit();


  const { desktopCondition } = useMediaQueries();

  useEffect(() => {
    if (captchaToken) {
      createEmbedPage(submitData);

      setCaptchaToken(null);
      setIsCaptchaShown(false);
    }
  }, [captchaToken, submitData]);

  const createEmbedPage = async ({ companyName, activeFormLists }) => {
    setLoadingCreatePage(true);

    if (!captchaToken) {
      setIsCaptchaShown(true);
      setSubmitData({ companyName, activeFormLists });
      if (getBasicSettingsData()?.recaptchaType === "google") {
        await awaiter(RECAPTCHA_APPEAR_DELAY);
        await recaptchaRef.current.executeAsync();
      }
      setLoadingCreatePage(false);
      return;
    }

    const body = {
      Occupation: "",
      EmbedDynamicPageCompanyName: companyName,
      EmbedDynamicPageActive: true,
      EmbedDynamicPageDirection: getDirection(),
      EmbedPageCulture: getLanguageCulture(),
      ShortCulture: getLanguage(),
      isProfilePages: true,
      EmbedDynamicPageFormIdsList: activeFormLists,
      recaptchaResponse: captchaToken,
    };

    const response = await apiRequest(
      "EmbedDynamics",
      "CreateEmbedPageReact",
      body,
      "POST"
    );
    if (response.status === "success") {
      setLoadingCreatePage(false);
      if (response.data) {
        if (response.data.EmbedDybamicPageResponseCode === 0) {
          let embedPage =
            config.baseurl + getPath() + "page-edit/" + response.data.UserName;
          window.location.href = embedPage;
        } else if (response.data.EmbedDybamicPageResponseCode === 460017) {
        }
      }
    } else {
      setLoadingCreatePage(false);
    }
  };

  useEffect(() => {
    if (isUpdateFormList) {
      if (dynamicFormsList && dynamicFormsList.length > 0) {
        setEmptyListForms(false);
      } else {
        setEmptyListForms(true);
      }
      setIsUpdateFormList(false);
    }
  }, [isUpdateFormList, dynamicFormsList]);

  const openLimitModal = () => {
    setModal(() => <EmbedLimitOptionsModal />);
  };

  if (!isPageReady) {
    return null;
  }

  return (
    <>
      {notExistEmbedPage && (
        <div className="embed-page-header">
          {isCaptchaShown ? (
            <Recaptcha
              recaptchaRef={recaptchaRef}
              onSuccess={(token) => setCaptchaToken(token)}
            />
          ) : null}
          <div className="create-page-header-container">
            <span>{getTextByKey("create-embed-page-text")}</span>
            <Button
              className="embed-page-button"
              onClick={() =>
                setModal(() => (
                  <CreateEmbedPageModalNew
                    loadingCreatePage={loadingCreatePage}
                    setLoadingCreatePage={setLoadingCreatePage}
                    createPage={createEmbedPage}
                    dynamicFormsList={dynamicFormsList}
                  />
                ))
              }
            >
              <Icon name={"website-forms"}></Icon>
              <span>{getTextByKey("jumboforms-create-embedpage")}</span>
            </Button>
          </div>
        </div>
      )}
      {emptyListForms || dynamicFormsList.length > 0 ? (
        <div
          className={`form-management-container ${
            notExistEmbedPage && dynamicFormsList.length > 0
              ? "not-exist-embed-page-header"
              : ""
          }`}
        >
          <div className="form-management-title embed-page-title">
            {dynamicFormsList.length > 0 ? (
              <h3>
                {getTextByKey("profile-menu-jumboform-form-management")} (
                {dynamicFormsList.length})
              </h3>
            ) : (
              <h3>{getTextByKey("profile-menu-jumboform-form-management")}</h3>
            )}
            {dynamicFormsList.length > 0 ? (
              <div className="buttons">
                <LinkToNewTab isNewTab={true} page="inbox?t=received&f=jform">
                  <div className="edit-page-link" tabIndex="-1">
                    <Icon name="ordersForm" />
                    <span>{getTextByKey("go-to-my-orders")}</span>
                  </div>
                </LinkToNewTab>
                {embedPageUserName &&
                  (desktopCondition ? (
                    <>
                      <LinkToNewTab
                        isNewTab={true}
                        page={"page-edit/" + embedPageUserName}
                      >
                        <div className="edit-page-link" tabIndex="-1">
                          <Icon name={"pencil-alt-solid"}></Icon>
                          <span>
                            {getTextByKey("jumboforms-edit-embedpage")}
                          </span>
                        </div>
                      </LinkToNewTab>
                      {!getUserData()?.BucketName ? (
                        <LinkToNewTab
                          isNewTab
                          page={"page/" + embedPageUserName}
                        >
                          <div className="edit-page-link" tabIndex="-1">
                            <Icon name={"eye-light"}></Icon>
                            <span>
                              {getTextByKey("jumboforms-view-embedpage")}
                            </span>
                          </div>
                        </LinkToNewTab>
                      ) : (
                        <a
                          target="_blank"
                          href={
                            "https://" +
                            bucketName +
                            "/" +
                            getLanguage() +
                            "/page/" +
                            embedPageUserName
                          }
                          rel="noreferrer"
                        >
                          <div className="edit-page-link" tabIndex="-1">
                            <Icon name={"eye-light"}></Icon>
                            <span>
                              {getTextByKey("jumboforms-view-embedpage")}
                            </span>
                          </div>
                        </a>
                      )}
                    </>
                  ) : (
                    <div className="mobile-page-details">
                      <h2 className="my-page-title">
                        {getTextByKey("my-jumbopage-title")}
                      </h2>
                      <div className="jumbopage-icons">
                        <LinkToNewTab
                          isNewTab={true}
                          page={"page-edit/" + embedPageUserName}
                        >
                          <div className="edit-page-link" tabIndex="-1">
                            <Icon name={"pencil-alt-solid"}></Icon>
                          </div>
                        </LinkToNewTab>
                        <LinkToNewTab
                          isNewTab={true}
                          page={"page/" + embedPageUserName}
                        >
                          <div className="edit-page-link" tabIndex="-1">
                            <Icon name={"eye-light"}></Icon>
                          </div>
                        </LinkToNewTab>
                      </div>
                    </div>
                  ))}
                {dynamicFormsList &&
                dynamicFormsList.length > 0 &&
                !isPremium() ? (
                  <div className="create-form-link">
                    <Button tabIndex="-1" onClick={openLimitModal}>
                      <Icon name={"plus"}></Icon>
                      <span>{getTextByKey("jumboforms-create-form")}</span>
                    </Button>
                  </div>
                ) : (
                  <LinkToNewTab
                    isNewTab={true}
                    page={"create-form"}
                    classes="create-form-link"
                  >
                    <Button tabIndex="-1">
                      <Icon name={"plus"}></Icon>
                      <span>{getTextByKey("jumboforms-create-form")}</span>
                    </Button>
                  </LinkToNewTab>
                )}
              </div>
            ) : null}
          </div>
          <div className="form-list-container">
            {dynamicFormsList.length > 0 && !emptyListForms ? (
              dynamicFormsList.map((form, i) => (
                <DynamicEmbedForm
                  setIsUpdateFormList={setIsUpdateFormList}
                  embedPageUserName={embedPageUserName}
                  key={i}
                  i={i}
                  form={form}
                  dynamicFormsList={dynamicFormsList}
                  setDynamicFormsList={setDynamicFormsList}
                  userData={userData}
                  loadingFormId={loadingFormId}
                  setLoadingFormId={setLoadingFormId}
                />
              ))
            ) : (
              <div className="empty-forms-list">
                <div className="empty-forms-container">
                  <div className="">
                    <Icon
                      iconClass="no-forms-img"
                      name="no-forms"
                      xxxl="true"
                    />
                  </div>
                  <div className="no-forms-text">
                    {getTextByKey("jumboforms-empty-forms")}
                  </div>
                </div>
                <div className="create-new-forms">
                  <div className="create-new-forms-text">
                    {getTextByKey("jumboforms-create-form-text")}
                  </div>
                  <div className="create-new-forms-button">
                    <LinkToNewTab isNewTab={true} page={"create-form"}>
                      <Button tabIndex="-1">
                        <Icon name={"plus"}></Icon>
                        <span>{getTextByKey("jumboforms-create-form")}</span>
                      </Button>
                    </LinkToNewTab>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <LoaderContainer isLoading={loading}></LoaderContainer>
      )}
    </>
  );
};

export default FormManagement;
